import BioVerificationItemHeader from './BioVerificationItemHeader';
import { BadgeUserAccountStatus } from '@/components/custom';
import { IBioVerification } from '@/lib/interface.ts';
import { Button } from '@/components/ui/button.tsx';
import { Card } from '@/components/ui/card.tsx';
import { UserAccountStatusEnum } from '@/enums';

type TProps = {
	onVerify: (id: string, accept: boolean) => void;
	item: IBioVerification;
};

const BioVerificationItem = ({ item, onVerify }: TProps) => (
	<Card className='w-full animate__animated animate__fadeIn relative'>
		<BioVerificationItemHeader item={item} />
		<div className={'flex flex-row items-center justify-center gap-x-5 px-4 pb-4 pt-0'}>
			<Button
				variant={'default'}
				className={'w-full text-red-500 bg-red-100 hover:bg-red-200/80'}
				onClick={() => onVerify(item._id, false)}>
				Refuser
			</Button>
			<Button
				variant={'default'}
				className={'w-full text-green-600 bg-green-100 hover:bg-green-200/80'}
				onClick={() => onVerify(item._id, true)}>
				Accepter
			</Button>
		</div>
		<BadgeUserAccountStatus
			user={item.userData}
			title='Cet utilisateur est inactif'
			isVisible={l => l.accountStatus !== UserAccountStatusEnum.ACTIVE}
			className={'text-nowrap px-2 py-0.5 text-xs rounded-sm absolute -top-1.5 -right-1'} />
	</Card>
);

export default BioVerificationItem;
